import { render, staticRenderFns } from "./BaseMapMarker.vue?vue&type=template&id=0e882336&"
import script from "./BaseMapMarker.vue?vue&type=script&lang=js&"
export * from "./BaseMapMarker.vue?vue&type=script&lang=js&"
import style0 from "./BaseMapMarker.vue?vue&type=style&index=0&id=0e882336&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e882336')) {
      api.createRecord('0e882336', component.options)
    } else {
      api.reload('0e882336', component.options)
    }
    module.hot.accept("./BaseMapMarker.vue?vue&type=template&id=0e882336&", function () {
      api.rerender('0e882336', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseMapMarker.vue"
export default component.exports